<material-navbar></material-navbar>

<div id="swagger-container" #docsContainer></div>
